import { initialRequestState } from "../../utils/redux";

export function reset(state) {
  return {
    ...state,
    all: [...state.all].map((report) => initialRequestState(report))
  };
}
